import { Component } from "@angular/core";
import {
  PageProgressService, NotificationService,
 // InviteUserService, InviteUserModel
} from "@bt/core";

import { HttpErrorResponse } from "@angular/common/http";

@Component({
  selector: "app-invite-user",
  templateUrl: "./invite-user.component.html",
  styleUrls: ["./invite-user.component.scss"]
})
export class InviteUsersComponent {


  constructor(//private userService: InviteUserService,
    private notificationService: NotificationService,
    private pageProgressService: PageProgressService) {
   

  }



}


// WEBPACK FOOTER //
// ./src/app/admin/invite-user/invite-user.component.ts